module.exports = __webpack_public_path__ + "static/media/project-ehl.4fdf70ce.jpg";